var React = require('react');

function CloseIconPopup (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 1L1 13","stroke":"#111111","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13 13L1 1","stroke":"#111111","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseIconPopup.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CloseIconPopup;

CloseIconPopup.default = CloseIconPopup;
